const ImportDetailStep = () => {
  return <p>ImportDetailStep</p>;
};

export default ImportDetailStep;
